import { format, parseISO } from 'date-fns'

export const dateTimeStringFormat = (dateTimeString: string, pattern: string): string => {
  return format(parseISO(dateTimeString), pattern);
}